import { Debugger } from 'springroll';

/**
 * Singleton bridge for google analytics tracking
 *
 * https://projects.pbs.org/bitbucket/projects/SD/repos/springroll-google-analytics/
 *
 */

const CATEGORY = 'Game_Elinor Curious Campout';

let instance = null;

class GoogleAnalytics {
  constructor(plugin) {
    if (instance) {
      return instance;
    }
    instance = this;
    Debugger.log('log', 'GoogleAnalytics plugin registered');
    this._plugin = plugin;
    this.startTime = Date.now();

    window.addEventListener('unload', () => {
      this.track({
        action: 'endGame',
      });
    });

    return instance;
  }

  destroy() {
    instance = null;
    this._plugin = null;
  }

  track({ category = CATEGORY, action = '', label = '', value = '' }) {
    Debugger.log('log', 'GoogleAnalytics.track', category, action, label, value);
    this._plugin && this._plugin.event(category, action, label, value);
  }
}

export function getGA(plugin) {
  return new GoogleAnalytics(plugin);
}

export function addGoogleAnalyticsPlugin({ plugin }) {
  return new GoogleAnalytics(plugin);
}
